import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  return <div className="min-h-screen bg-navy text-slate-400 font-sans selection:bg-gold selection:text-navy flex flex-col" data-id="element-131">
      <Header data-id="element-132" />
      <main className="flex-grow" data-id="element-133">
        <Outlet data-id="element-134" />
      </main>
      <Footer data-id="element-135" />
    </div>;
}